import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import { useFormik } from "formik"
import * as Yup from "yup"
import * as icon from "@coreui/icons";
import moment from 'moment'

// components
import { CDateRangePicker } from '@coreui/react-pro'
import Select from 'react-select';
import AppCard from '../../components/AppCard'
import AppForm from '../../components/form/form-project/AppForm'
import ActionButtonForm from 'src/components/form/general-input-form/ActionButtonForm'
import AppModalConfirmation from '../../components/modal/AppModalConfirmation'
import FormFileThumbnail from '../../components/form/general-input-form/FormFileThumbnail'
import AppTable from '../../components/AppTable'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppModalFilePreview from 'src/components/modal/AppModalFilePreview'

// helpers
import Axios from '../../helpers/axios'
import { 
  singleClientsOptionsSelect, 
  singleExpenseIntervalOptionSelect, 
  singleStatusContractProjectOptionSelect, 
  singleCountriesOptionsSelect, 
  singleEmployeesOptionsSelect,
  singleCourierOptionSelect,
  singleExpenseCategoryOptionsSelect,
  singleExpenseTagsOptionsSelect,
  singleExpenseCategoryAirplaneOptionSelect,
  singleExpenseCategoryTransportOptionSelect,
  singleExpenseCategoryFuelOptionSelect,
  singleExpenseCategoryTripTypeOptionSelect,
  singleExpenseCategoryFlightOptionSelect,
  singleExpenseCategoryTrainOptionSelect,
  singlePaymentTempoOptionSelect,
  singleExpenseCategoryAccomodationOptionSelect
} from '../../helpers/format-options'
import { columnExpenseList, columnInvoiceList, columnSupportingLinksList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from 'src/helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'
import { timer } from "../../helpers/timer";
import { customStyles } from '../../components/custom-styles/selectStyles'

const EditProject = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { showError, showSuccess } = useToastMessage();
  const params = useParams()
  const { id } = params
  const user = JSON.parse(localStorage.getItem("user"))

  const isLoading = useSelector((state) => state.isLoading)

  const [projectDetail, setProjectDetail] = useState('')
  const [invoiceDetail, setInvoiceDetail] = useState('')
  const [expenseDetail, setExpenseDetail] = useState('')
  const [supportingLinkDetail, setSupportingLinkDetail] = useState('')

  const [intervalValue, setIntervalValue] = useState({
    label: 'No repeat',
    value: 'no repeat'
  })

  const [client, setClient] = useState({})
  const [clientOptions, setClientOptions] = useState(false)
  const [countryOptions, setCountryOptions] = useState([])

  const [showConfirmAddContract, setShowConfirmAddContract] = useState({ show: false, item: {} })
  const [showConfirmAddOtherFiles, setShowConfirmAddOtherFiles] = useState({ show: false, item: {} })
  const [showConfirmAddInvoices, setShowConfirmAddInvoices] = useState({ show: false, item: {} })
  const [showConfirmAddExpenses, setShowConfirmAddExpenses] = useState({ show: false, item: {} })
  const [showModalAddSupportingLinks, setShowModalAddSupportingLinks] = useState({ show: false, item: {} })

  const [showDeleteItem, setShowDeleteItem] = useState({ show: false, type: '', item: {}, index: 0 })
  const [showConfirmEdit, setShowConfirmEdit] = useState({ show: false, type: '', item: {} })
  const [showConfirmDuplicate, setShowConfirmDuplicate] = useState({ show: false, type: '', item: {} })
  const [showConfirmView, setShowConfirmView] = useState({ show: false, type: '', item: {} })
  const [showConfirmAddAttachments, setShowConfirmAddAttachments] = useState({ show: false, item: {} })
  const [showConfirmChangeStatusContract, setShowConfirmChangeStatusContract] = useState({ show: false, item: {}, value: null })

  const [showModalConfirm, setShowModalConfirm] = useState({ show: false, type: '', text: '' })
  const [headerTitle, setHeaderTitle] = useState('')

  const [invoiceListPerPage, setInvoiceListPerPage] = useState(10);
  const [activeInvoiceListPage, setActiveInvoiceListPage] = useState(1);
  const [searchInvoiceListFilter, setSearchInvoiceListFilter] = useState("");
  const [columnInvoiceListSorter, setColumnInvoiceListSorter] = useState({ column: "createdAt", state: "DESC" });

  const [expenseListPerPage, setExpenseListPerPage] = useState(10);
  const [expenseListCount, setExpenseListCount] = useState(0);
  const [activeExpenseListPage, setActiveExpenseListPage] = useState(1);
  const [searchExpenseListFilter, setSearchExpenseListFilter] = useState("");
  const [columnExpenseListSorter, setColumnExpenseListSorter] = useState({ column: "createdAt", state: "DESC" });

  const [invoiceList, setInvoiceList] = useState([])
  const [expenseList, setExpenseList] = useState([])

  const [employeeOptions, setEmployeeOptions] = useState([])
  const [employees, setEmployees] = useState(null)

  const [paymentTempoValue, setPaymentTempoValue] = useState(null)

  const [expenseCategoryOptions, setExpenseCategoryOptions] = useState([])
  const [expenseCategoryValue, setExpenseCategoryValue] = useState(null)
  const [expenseAirplaneValue, setExpenseAirplaneValue] = useState(null)
  const [expenseTransportationValue, setExpenseTransportationValue] = useState(null)
  const [expenseFuelValue, setExpenseFuelValue] = useState(null)
  const [expenseFlightValue, setExpenseFlightValue] = useState(null)
  const [expenseTrainValue, setExpenseTrainValue] = useState(null)
  const [expenseAccomodationValue, setExpenseAccomodationValue] = useState(null)
  const [expenseAccomodationProvinceValue, setExpenseAccomodationProvinceValue] = useState(null)
  const [expenseAccomodationCitiesValue, setExpenseAccomodationCitiesValue] = useState(null)
  const [expenseTagsOptions, setExpenseTagsOptions] = useState([])

  const [provinceOptions, setProvinceOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);

  const [openFilePreview, setOpenFilePreview] = useState(false)

  const [searchClientListFilter, setSearchClientListFilter] = useState("");

  const [picList, setPicList] = useState([])
  const [picValue, setPicValue] = useState(null)
  
  const [filterStartDateExpense, setFilterStartDateExpense] = useState(null)
  const [filterEndDateExpense, setFilterEndDateExpense] = useState(null)
  const [columnExpenseFilter, setColumnExpenseFilter] = useState({})
  const [updateColumnExpenseList, setUpdateColumnExpenseList] = useState(columnExpenseList)

  const formik = useFormik({
    initialValues: {
      project_name: projectDetail?.name,
      project_description: projectDetail?.description,
      project_value: projectDetail?.value,
      project_tax_value: projectDetail?.tax_value,
      project_start_date: projectDetail?.start_date,
      project_end_date: projectDetail?.end_date,
      client_value: {
        label: projectDetail?.client?.name,
        value: projectDetail?.client_id
      },
      project_contracts: projectDetail?.contracts?.length > 0 ? projectDetail?.contracts : [],
      project_supporting_files: projectDetail?.other_supporting_files?.length > 0 ? projectDetail?.other_supporting_files : [],
      project_supporting_docs: projectDetail?.supporting_links || [],
      invoices: projectDetail?.invoices?.length > 0 ? projectDetail?.invoices : [],
      expenses: projectDetail?.expenses?.length > 0 ? projectDetail?.expenses : [],
      is_purchase_order: projectDetail?.purchase_orders?.length > 0 ? true : false,
      project_purchase_orders: projectDetail?.purchase_orders?.length > 0 ? projectDetail.purchase_orders : [
        {
          order_number: '',
          order_value: '',
          order_created: '',
          order_notes: '',
          purchase_order_file: []
        }
      ],
      project_employees: employees,
      project_terms: projectDetail?.terms?.length > 0 ? projectDetail.terms?.map((val) => {
        return {
          id: val?.id || '',
          term_name: val?.term_name || '',
          term_percentage: val?.percentage || '',
          term_value: val?.value || '',
          term_tax_value: val?.tax_value || ''
        }
      }) : [
        {
          term_name: '',
          term_percentage: '',
          term_value: '',
          term_tax_value: ''
        }
      ],
      project_payment_tempo: projectDetail?.payment_tempo || '',
      project_other_payment_tempo: projectDetail?.other_payment_tempo || '',
      project_progress_status: projectDetail?.status || '',
      terms_invoice: projectDetail?.terms_invoice || false,
      terms_bast: projectDetail?.terms_bast || false,
      terms_po: projectDetail?.terms_po || false,
      terms_faktur_pajak: projectDetail?.terms_faktur_pajak || false,
      terms_pkp: projectDetail?.terms_pkp || false,
      terms_npwp: projectDetail?.terms_npwp || false,
      terms_progress_report: projectDetail?.terms_progress_report || false,
      terms_additional_info: projectDetail?.terms_additional_info || ''
    },
    validationSchema: Yup.object().shape({
      project_name: Yup.string()
        .required("Please enter project name."),
      project_description: Yup.string()
        .required("Please enter project description."),
      project_value: Yup.string()
        .required("Please enter project value."),
      project_tax_value: Yup.string()
        .required("Please enter project tax and other fees."),
      project_start_date: Yup.string()
        .required("Please select project start date."),
      project_end_date: Yup.string()
        .required("Please select project end date."),
      client_value: Yup.object().shape({
        label: Yup.string().required('Please select client name.')
      }).required('Please select client name.'),
      project_purchase_orders: Yup.array()
      .when('is_purchase_order', {
        is: true,
        then: (schema) => schema
          .of(
            Yup.object().shape({
              order_number: Yup.string().required("Please enter order number."),
              order_value: Yup.string().required("Please enter order value."),
              order_created: Yup.string().required("Please select order created on."),
              purchase_order_file: Yup.array().min(1, 'Please add at least one attachment')
            })
          ).min(1, 'Please add at least one purchase order.'),
        otherwise: (schema) => schema
      }),
      project_terms: Yup.array()
        .of(
          Yup.object().shape({
            term_name: Yup.string().required("Please enter term name."),
            term_percentage: Yup.string().required("Please enter term percentage."),
            term_value: Yup.string().required("Please enter term value."),
            term_tax_value: Yup.string().required("Please enter term tax value."),
          })
        ).min(1, 'Please add at least one project terms.'),
      project_payment_tempo: Yup.string()
        .required("Please select payment tempo."),
      project_other_payment_tempo: Yup.string()
        .when('project_payment_tempo', {
          is: 'Others',
          then: (schema) => schema.required("Please enter other payment tempo."),
          otherwise: (schema) => schema
        }),
      project_progress_status: Yup.string()
        .required("Please select project progress status."),
    }),
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting }) => {
      handleSave(values)
      setSubmitting(false)
    },
  });

  const formikSupportingLink = useFormik({
    initialValues: {
      file_name: supportingLinkDetail?.file_name ? supportingLinkDetail.file_name : '',
      file_description: supportingLinkDetail?.file_description ? supportingLinkDetail.file_description : '',
      file_url: supportingLinkDetail?.file_url ? supportingLinkDetail.file_url : '',
    },
    validationSchema: Yup.object().shape({
      file_name: Yup.string()
        .required("Please enter file name."),
      file_description: Yup.string()
        .required("Please enter file description."),
      file_url: Yup.string()
        .required("Please enter file url."),
    }),
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      handleSaveSupportingLink(values)
      resetForm()
      setSubmitting(false)
    },
  });

  const formikInvoice = useFormik({
    initialValues: {
      invoice_name: invoiceDetail?.name ? invoiceDetail.name : '',
      invoice_description: invoiceDetail?.description ? invoiceDetail.description : '',
      invoice_value: invoiceDetail?.value ? invoiceDetail.value : '',
      invoice_tax_value: invoiceDetail?.tax_value ? invoiceDetail.tax_value : '',
      invoice_due_date: invoiceDetail?.due_date ? invoiceDetail.due_date : '',
      invoice_expected_payment_date: invoiceDetail?.expected_payment_date ? invoiceDetail.expected_payment_date : '',
      invoice_tax_due_date: invoiceDetail?.tax_due_date ? invoiceDetail.tax_due_date : '',
      invoice_is_paid: invoiceDetail?.is_paid || false,
      invoice_payment_date: invoiceDetail?.payment_date ? invoiceDetail?.payment_date : '',
      invoice_bupot_required: invoiceDetail?.bupot_required ? invoiceDetail?.bupot_required : false,
      invoice_faktur_required: invoiceDetail?.faktur_required ? invoiceDetail?.faktur_required : false,
      file: invoiceDetail?.attachments || [],
      file_generate_pdf: invoiceDetail?.generate_pdf_attachments || [],
      file_bupot: invoiceDetail?.bupot_url ? [{ file_url: invoiceDetail?.bupot_url, file_original_name: invoiceDetail?.bupot_original_name }] : [],
      file_faktur: invoiceDetail?.faktur_url ? [{ file_url: invoiceDetail?.faktur_url, file_original_name: invoiceDetail?.faktur_original_name }] : [],
      invoice_number: invoiceDetail?.invoice_number || '',
      invoice_is_draft: invoiceDetail?.is_draft ? true : false,
      recipients: invoiceDetail?.recipients?.length > 0 ? invoiceDetail?.recipients : [
        {
          recipient_name: null,
          phone_number: '',
          country_id: '',
          country_value: null,
          recipient_email: '',
        }
      ],
      client_value: projectDetail?.client ? {
        label: projectDetail?.client?.name,
        value: projectDetail?.client?.id
      } : null,
      project_value: projectDetail?.name ? {
        label: projectDetail?.name,
        value: projectDetail?.id
      } : null,
      invoice_shipping_detail: invoiceDetail?.shipping_detail ? {
        ...invoiceDetail?.shipping_detail,
        courier: invoiceDetail?.shipping_detail ? singleCourierOptionSelect()?.filter((item) => item.value == invoiceDetail?.shipping_detail?.courier)[0] : null
      } : {
        invoice_id: id,
        is_soft_copy: false,
        is_hard_copy: false,
        recipient: '',
        email_to: '',
        email_date: '',
        courier: null,
        tracking_no: '',
        shipping_date: '',
      },
      file_shipping: invoiceDetail?.shipping_detail?.file_url ? [{ file_url: invoiceDetail?.shipping_detail?.file_url, file_original_name: invoiceDetail?.shipping_detail?.file_original_name }] : []
    },
    validationSchema: Yup.object().shape({
      invoice_name: Yup.string()
        .required("Please enter invoice name."),
      invoice_description: Yup.string()
        .required("Please enter invoice description."),
      invoice_value: Yup.string()
        .required("Please enter invoice value."),
      invoice_tax_value: Yup.string()
        .required("Please enter invoice tax and other fees."),
      invoice_due_date: Yup.string()
        .required("Please select invoice due date."),
      invoice_expected_payment_date: Yup.string()
        .required("Please select invoice expected payment date."),
      invoice_tax_due_date: Yup.string()
        .required("Please select invoice tax due date."),
      invoice_payment_date: Yup.string()
        .when('invoice_is_paid', {
          is: true,
          then: () => Yup.string().required('Please select invoice payment date')
        }),
      recipients: Yup.array()
        .of(
          Yup.object().shape({
            recipient_name: Yup.string().required("Please enter recipient name."),
            phone_number: Yup.string().required("Please enter recipient contact number."),
            country_value: Yup.string().required("Please select country of recipient."),
            recipient_email: Yup.string().required("Please enter recipient email."),
          })
        ).min(1, 'Please add at least one recipient'),
      invoice_shipping_detail: Yup.object()
      .when(['is_soft_copy', 'is_hard_copy'], {
        is: (is_soft_copy, is_hard_copy) => is_soft_copy == true || is_hard_copy == true,
        then: () => Yup.object().shape({
          is_soft_copy: Yup.boolean(),
          is_hard_copy: Yup.boolean(),
          recipient: Yup.string().when('is_soft_copy', {
            is: true,
            then: (schema) => schema.required('Please enter recipient name.')
          }),
          email_to: Yup.string().when('is_soft_copy', {
            is: true,
            then: (schema) => schema.required('Please enter email to.')
          }),
          email_date: Yup.string().when('is_soft_copy', {
            is: true,
            then: (schema) => schema.required('Please select email date.')
          }),
          courier: Yup.object().when('is_hard_copy', {
            is: true,
            then: () => Yup.object().shape({
              label: Yup.string().required('Please select courier.')
            })
          }),
          tracking_no: Yup.string().when('is_hard_copy', {
            is: true,
            then: (schema) => schema.required('Please enter tracking number.')
          }),
          shipping_date: Yup.string().when('is_hard_copy', {
            is: true,
            then: (schema) => schema.required('Please select shipping date.')
          }),
        }),
      })
    }),
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      handleSaveInvoice(values)
      setSubmitting(false)
    },
  });

  const formikExpense = useFormik({
    initialValues: {
      expense_name: expenseDetail?.name ? expenseDetail.name : '',
      expense_description: expenseDetail?.description ? expenseDetail.description : '',
      expense_value: expenseDetail?.value ? expenseDetail.value : '',
      expense_date: expenseDetail?.date ? expenseDetail.date : '',
      expense_repeat_start_date: expenseDetail?.repeat_start_date ? expenseDetail.repeat_start_date : '',
      expense_repeat_end_date: expenseDetail?.repeat_end_date ? expenseDetail.repeat_end_date : '',
      expense_repeat_forever: expenseDetail?.expense_repeat_forever ? expenseDetail.expense_repeat_forever : false,
      expense_repeat_interval: expenseDetail?.repeat_interval ? expenseDetail.repeat_interval : 'no repeat',
      expense_notes: expenseDetail?.notes || '',
      file: expenseDetail?.attachment_url ? [{attachment_url: expenseDetail.attachment_url, attachment_original_name: expenseDetail?.attachment_original_name}] : [],
      is_related_to_project: null,
      category_id: expenseDetail?.category_id || '',
      category_value: expenseDetail?.category_value || null,
      expense_flight: {
        reservation_number: expenseDetail?.flight?.reservation_number || "",
        airplane_name:  expenseDetail?.flight?.airplane_name || "",
        flight_details: expenseDetail?.flight?.flight_details || "",
        flight_type: expenseDetail?.flight?.flight_type || "", // One Way / Return
        reservation_date_1: expenseDetail?.flight?.reservation_date_1 || "",
        reservation_date_2: expenseDetail?.flight?.reservation_date_2 || "",
        booking_through: expenseDetail?.flight?.booking_through || "",
        other_booking_input: expenseDetail?.flight?.other_booking_input || "",
        passengers: expenseDetail?.flight?.passengers?.length > 0 ? expenseDetail?.flight?.passengers : [
          { first_name: "", last_name: "" }
        ]
      },
      expense_accomodation: {
        reservation_number: expenseDetail?.accomodation?.reservation_number || "",
        accomodation_name:  expenseDetail?.accomodation?.accomodation_name || "",
        accomodation_details: expenseDetail?.accomodation?.accomodation_details || "",
        accomodation_address: expenseDetail?.accomodation?.accomodation_address || "",
        accomodation_country_id: 104, // Default to Indonesia
        accomodation_province_id: expenseDetail?.accomodation?.province?.id || '',
        accomodation_city_id: expenseDetail?.accomodation?.city?.id || '',
        is_booking_more_than_one_day: expenseDetail?.accomodation?.reservation_date_2 ? true : false,
        reservation_date_1: expenseDetail?.accomodation?.reservation_date_1 || "",
        reservation_date_2: expenseDetail?.accomodation?.reservation_date_2 || "",
        booking_through: expenseDetail?.accomodation?.booking_through || "",
        other_booking_input: expenseDetail?.accomodation?.other_booking_input || "",
        guests: expenseDetail?.accomodation?.guests?.length > 0 ? expenseDetail?.accomodation?.guests : [
          { first_name: "", last_name: "" }
        ]
      },
      expense_train: {
        reservation_number: expenseDetail?.train?.reservation_number || "",
        train_name: expenseDetail?.train?.train_name || "",
        train_details: expenseDetail?.train?.train_details || "",
        train_type: expenseDetail?.train?.train_type || "",
        reservation_date_1: expenseDetail?.train?.reservation_date_1 || "",
        reservation_date_2: expenseDetail?.train?.reservation_date_2 || "",
        booking_through: expenseDetail?.train?.booking_through || "",
        other_booking_input: expenseDetail?.train?.other_booking_input || "",
        passengers: expenseDetail?.train?.passengers?.length > 0 ? expenseDetail?.train?.passengers : [
          { first_name: "", last_name: "" }
        ]
      },
      expense_car_rental: {
        rental_company: expenseDetail?.car_rental?.rental_company || "",
        description: expenseDetail?.car_rental?.description || "",
        car_type: expenseDetail?.car_rental?.car_type || "",
        booking_start: expenseDetail?.car_rental?.booking_start || "",
        booking_end: expenseDetail?.car_rental?.booking_end || "",
        is_booking_more_than_one_day: expenseDetail?.car_rental?.booking_end ? true : false
      },
      expense_pettycash_operational: {
        datetime: expenseDetail?.pettycash_operational?.datetime || "",
        description: expenseDetail?.pettycash_operational?.description || "",
        tags: expenseDetail?.pettycash_operational?.pettycash_tags?.length > 0 ? expenseDetail?.pettycash_operational?.pettycash_tags?.map((val) => ({
          label: val?.tags?.name,
          value: val?.tags?.id
        })) : []
      },
      expense_meals: {
        restaurant_name: expenseDetail?.meal?.restaurant_name || "",
        datetime: expenseDetail?.meal?.datetime || "",
        description: expenseDetail?.meal?.description || ""
      },
      expense_fuel: {
        company_name: expenseDetail?.fuel?.company_name || "",
        other_company_input: expenseDetail?.fuel?.other_company_input || "",
        datetime: expenseDetail?.fuel?.datetime || "",
        description: expenseDetail?.fuel?.description || ""
      },
      expense_etoll: {
        datetime: expenseDetail?.etoll?.datetime || "",
        description: expenseDetail?.etoll?.datetime || ""
      },
      expense_transportation: {
        datetime: expenseDetail?.transportation?.datetime || "",
        transportation_category: expenseDetail?.transportation?.transportation_category || "",
        other_transportation_input: expenseDetail?.transportation?.other_transportation_input || "",
        description: expenseDetail?.transportation?.description || ""
      },
      expense_office_supplies: {
        company: expenseDetail?.office_supply?.company || "",
        datetime: expenseDetail?.office_supply?.datetime || "",
        description: expenseDetail?.office_supply?.description || ""
      },
      expense_printing: {
        company: expenseDetail?.printing?.company || "",
        datetime: expenseDetail?.printing?.datetime || "",
        description: expenseDetail?.printing?.description || ""
      },
      expense_other_reimbursement: {
        reimbursement_for: expenseDetail?.other_reimbursement?.reimbursement_for || "",
        company: expenseDetail?.other_reimbursement?.company || "",
        datetime: expenseDetail?.other_reimbursement?.datetime || "",
        description: expenseDetail?.other_reimbursement?.description || ""
      }
    },
    validationSchema: Yup.object().shape({
      expense_name: Yup.string()
        .required("Please enter expense name."),
      expense_description: Yup.string()
        .required("Please enter expense description."),
      expense_value: Yup.string()
        .required("Please enter expense value."),
      expense_date: Yup.string()
        .when(['expense_repeat_interval'], {
          is: (expense_repeat_interval) => expense_repeat_interval === 'no repeat',
          then: () => Yup.string().required("Please select expense date."),
        }),
      expense_repeat_start_date: Yup.string()
        .when(['expense_repeat_interval'], {
          is: (expense_repeat_interval) => expense_repeat_interval !== 'no repeat',
          then: () => Yup.string().required("Please select expense repeat start date."),
        }),
      expense_repeat_end_date: Yup.string()
        .when(['expense_repeat_forever', 'expense_repeat_interval'], {
          is: (expense_repeat_forever, expense_repeat_interval) => expense_repeat_forever == false && expense_repeat_interval !== 'no repeat',
          then: () => Yup.string().required('Please select expense repeat end date.')
        }),
      expense_repeat_interval: Yup.string()
        .required("Please select expense repeat interval."),
      expense_flight: Yup.object().when("category_value", {
        is: (category_value) => category_value?.label == 'Flight',
        then: () => Yup.object({
          reservation_number: Yup.string().required('Please enter reservation number'),
          airplane_name: Yup.string().required('Please enter airplane name'),
          flight_details: Yup.string().required('Please enter flight detail'),
          flight_type: Yup.string().required('Please select flight type'),
          reservation_date_1: Yup.string()
          .when("flight_type", {
            is: (flight_type) => flight_type == 'One way' || flight_type == 'Return',
            then: (flight_type) => Yup.string().required(flight_type == 'One way' ? 'Please select flight date' : 'Please select flight departure date'),
          }),
          reservation_date_2: Yup.string()
          .when("flight_type", {
            is: (flight_type) => flight_type == 'Return',
            then: () => Yup.string().required('Please select flight return date')
          }),
          booking_through: Yup.string().required('Please select booking through'),
          other_booking_input: Yup.string().when("booking_through", {
            is: (booking_through) => booking_through == 'Others',
            then: () => Yup.string().required("Please specify")
          }),
          passengers: Yup.array().of(
            Yup.object({
              first_name: Yup.string().required('Please enter first name'),
              last_name: Yup.string().required('Please enter last name')
            })
          ).min(1, 'Please add at least one passenger')
        })
      }),
      expense_accomodation: Yup.object().when("category_value", {
        is: (category_value) => category_value?.label == 'Accomodation',
        then: () => Yup.object({
          reservation_number: Yup.string().required('Please enter reservation number'),
          accomodation_name: Yup.string().required('Please enter accomodation name'),
          accomodation_details: Yup.string().required('Please enter accomodation detail'),
          accomodation_address: Yup.string().required('Please enter accomodation address'),
          accomodation_province_id: Yup.string().required('Please select accomodation province'),
          accomodation_city_id: Yup.string().required('Please select accomodation city'),
          is_booking_more_than_one_day: Yup.boolean(),
          reservation_date_1: Yup.string()
          .when("is_booking_more_than_one_day", {
            is: (is_booking_more_than_one_day) => is_booking_more_than_one_day == true || is_booking_more_than_one_day == false,
            then: (is_booking_more_than_one_day) => Yup.string().required(is_booking_more_than_one_day ? 'Please select reservation start date' : 'Please select reservation date'),
          }),
          reservation_date_2: Yup.string()
          .when("is_booking_more_than_one_day", {
            is: (is_booking_more_than_one_day) => is_booking_more_than_one_day == true,
            then: () => Yup.string().required('Please select reservation end date')
          }),
          booking_through: Yup.string().required('Please select booking through'),
          other_booking_input: Yup.string().when("booking_through", {
            is: (booking_through) => booking_through == 'Others',
            then: () => Yup.string().required("Please specify")
          }),
          guests: Yup.array().of(
            Yup.object({
              first_name: Yup.string().required('Please enter first name'),
              last_name: Yup.string().required('Please enter last name')
            })
          ).min(1, 'Please add at least one guest')
        })
      }),
      expense_train: Yup.object().when("category_value", {
        is: (category_value) => category_value?.label == 'Train',
        then: () => Yup.object({
          reservation_number: Yup.string().required('Please enter reservation number'),
          train_name: Yup.string().required('Please enter train name'),
          train_details: Yup.string().required('Please enter train detail'),
          train_type: Yup.string().required('Please select train type'),
          reservation_date_1: Yup.string()
          .when("train_type", {
            is: (train_type) => train_type == 'One way' || train_type == 'Return' || train_type == '',
            then: (train_type) => Yup.string().required(train_type !== '' ? train_type == 'One way' ? 'Please select train date' : 'Please select train departure date' : 'Please select train date'),
          }),
          reservation_date_2: Yup.string()
          .when("train_type", {
            is: (train_type) => train_type == 'Return',
            then: () => Yup.string().required('Please select train return date')
          }),
          booking_through: Yup.string().required(),
          other_booking_input: Yup.string().when("booking_through", {
            is: (booking_through) => booking_through == 'Others',
            then: () => Yup.string().required("Please specify")
          }),
          passengers: Yup.array().of(
            Yup.object({
              first_name: Yup.string().required('Please enter first name'),
              last_name: Yup.string().required('Please enter last name')
            })
          ).min(1, 'Please add at least one passenger')
        })
      }),
      expense_car_rental: Yup.object().when("category_value", {
        is: (category_value) => category_value?.label == 'Car rental',
        then: () => Yup.object({
          rental_company: Yup.string().required('Please enter company'),
          description: Yup.string().required('Please enter description'),
          car_type: Yup.string().required('Please enter car type'),
          is_booking_more_than_one_day: Yup.boolean(),
          booking_start: Yup.string()
          .when("is_booking_more_than_one_day", {
            is: (is_booking_more_than_one_day) => is_booking_more_than_one_day == true || is_booking_more_than_one_day == false,
            then: (is_booking_more_than_one_day) => Yup.string().required(is_booking_more_than_one_day ? 'Please select booking start date' : 'Please select booking period'),
          }),
          booking_end: Yup.string()
          .when("is_booking_more_than_one_day", {
            is: (is_booking_more_than_one_day) => is_booking_more_than_one_day == true,
            then: () => Yup.string().required('Please select booking end date')
          }),
        })
      }),
      expense_pettycash_operational: Yup.object().when("category_value", {
        is: (category_value) => {
          category_value?.label == 'Pettycash & Operational'
        },
        then: () => Yup.object({
          datetime: Yup.string().required('Please select date time'),
          description: Yup.string().required('Please enter description'),
          tags: Yup.array().of(Yup.string().required())
        })
      }),
      expense_meals: Yup.object()
        .when("category_value", {
          is: (category_value) => category_value?.label === 'Meals',
          then: () => Yup.object({
            restaurant_name: Yup.string().required('Please enter restaurant name'),
            datetime: Yup.string().required('Please select date time'),
            description: Yup.string().required('Please enter description')
          })
        }),
      expense_fuel: Yup.object().when("category_value", {
        is: (category_value) => category_value?.label == 'Fuel',
        then: () => Yup.object({
          company_name: Yup.string().required('Please enter company name'),
          other_company_input: Yup.string().when("company_name", {
            is: (company_name) => company_name == "Others",
            then: () => Yup.string().required("Please specify")
          }),
          datetime: Yup.string().required('Please select date time'),
          description: Yup.string().required('Please enter description')
        })
      }),
      expense_etoll: Yup.object().when("category_value", {
        is: (category_value) => category_value?.label == 'E-toll money',
        then: () => Yup.object({
          datetime: Yup.string().required('Please select date time'),
          description: Yup.string().required('Please enter description')
        })
      }),
      expense_transportation: Yup.object().when("category_value", {
        is: (category_value) => category_value?.label == 'Transportation',
        then: () => Yup.object({
          datetime: Yup.string().required('Please select date time'),
          transportation_category: Yup.string().required('Please select transportation'),
          other_transportation_input: Yup.string().when("transportation_category", {
            is: (transportation_category) => transportation_category == "Others",
            then: () => Yup.string().required("Please specify")
          }),
          description: Yup.string().required('Please enter description')
        })
      }),
      expense_office_supplies: Yup.object().when("category_value", {
        is: (category_value) => category_value?.label == 'Office supplies / stationery',
        then: () => Yup.object({
          company: Yup.string().required('Please enter company'),
          datetime: Yup.string().required('Please select datetime'),
          description: Yup.string().required('Please enter description')
        })
      }),
      expense_printing: Yup.object().when("category_value", {
        is: (category_value) => category_value?.label == 'Printing',
        then: () => Yup.object({
          company: Yup.string().required('Please enter company'),
          datetime: Yup.string().required('Please select datetime'),
          description: Yup.string().required('Please enter description')
        })
      }),
      expense_other_reimbursement: Yup.object().when("category_value", {
        is: (category_value) => category_value?.label == 'Other reimbursement',
        then: () => Yup.object({
          reimbursement_for: Yup.string().required('Please enter reimbursement for'),
          company: Yup.string().required('Please enter company'),
          datetime: Yup.string().required('Please select date time'),
          description: Yup.string().required('Please enter description')
        })
      })
    }),
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      handleSaveExpense(values)
      resetForm()
      setSubmitting(false)
    },
  });

  useEffect(() => {
    fetchDetailProject()
    fetchAllClient()
    fetchAllCountries()

    if (user?.role_id == 1) {
      fetchAllExpenseCategories()
      fetchAllExpenseTags()
      fetchAllEmployee()
    }
  }, [id])

  useEffect(() => {
    if (expenseCategoryValue?.label == 'Accomodation') {
      fetchAllProvince()
    }
  }, [expenseCategoryValue])

  useEffect(() => {
    let queries = handleQueriesInvoice()
    fetchAllInvoice(queries)
  }, [
    searchInvoiceListFilter,
    invoiceListPerPage,
    activeInvoiceListPage,
    columnInvoiceListSorter
  ])

  useEffect(() => {
    if (user?.role_id != 1) return;

    let queries = handleQueriesExpense()
    fetchAllExpense(queries)
  }, [
    searchExpenseListFilter,
    expenseListPerPage,
    activeExpenseListPage,
    columnExpenseListSorter,
    columnExpenseFilter
  ])

  useEffect(() => {
    let queries = {
      search: searchClientListFilter,
      limit: 10,
      offset: 0,
    };
    queries = formUrlQuery(queries);
    if (searchClientListFilter) {
      fetchAllClient(queries)
    } else {
      setClientOptions([])
    }
  }, [
    searchClientListFilter
  ])

  useEffect(() => {
    const firstErrorKey = Object.keys(formik.errors)[0];
    
    if (firstErrorKey) {
      const beforeFunction = () => {
        showError('There are fields that have not been filled in, please check again.')
        const errorElement = document.querySelector(`[id="${firstErrorKey}"]`);
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
          errorElement.focus();
        }
      };
      const afterFunction = () => {
        return  dispatch({
          type: 'SET_TOAST_MESSAGE',
          toastMessage: {
            isError: false,
            isShown: false,
            color: '',
            text: ''
          }
        })
      };
      timer(beforeFunction, afterFunction, 2000);
    }
  }, [formik.isSubmitting])

  useEffect(() => {
    let columnList = updateColumnExpenseList?.map((list) => {
      let data = list

      if (data.key == 'category_name' && expenseCategoryOptions?.length > 0) {
        data.filter = (_, onChange) => {
          return (
            <Select
              options={expenseCategoryOptions}
              value={columnExpenseFilter.category_id}
              onChange={(e) => {
                const selectedValue = e;
                onChange(selectedValue);
                setColumnExpenseFilter((prevState) => ({
                  ...prevState,
                  category_id: selectedValue
                }));
                setActiveExpenseListPage(1)
              }}
              isClearable
              styles={customStyles}
            />
          )
        }
      }

      if (data.key == 'date') {
        data.filter = () => {
          return (
            <CDateRangePicker
              footer
              cleaner
              size="sm"
              startDate={filterStartDateExpense}
              endDate={filterEndDateExpense}
              onStartDateChange={(date) => {
                if (date) {
                  const itemDate = moment(date).format('YYYY-MM-DD')
                  setFilterStartDateExpense(itemDate)
                  
                  setColumnExpenseFilter((prevState) => ({
                    ...prevState,
                    start_date: {
                      value: itemDate,
                    }
                  }));

                  if (filterEndDateExpense) {
                    setActiveExpenseListPage(1)
                  }
                } else {
                  setColumnExpenseFilter((prevState) => ({
                    ...prevState,
                    start_date: null
                  }));
                }
              }}
              onEndDateChange={(date) => {
                if (date) {
                  const itemDate = moment(date).format('YYYY-MM-DD')
                  setFilterEndDateExpense(itemDate)
                  
                  setColumnExpenseFilter((prevState) => ({
                    ...prevState,
                    end_date: {
                      value: itemDate,
                    }
                  }));

                  if (filterStartDateExpense) {
                    setActiveExpenseListPage(1)
                  }
                } else {
                  setColumnExpenseFilter((prevState) => ({
                    ...prevState,
                    end_date: null
                  }));
                }
              }}
            />
          )
        }
      }

      return data
    })

    setUpdateColumnExpenseList(columnList)
  }, [columnExpenseFilter, expenseCategoryOptions])

  const fetchDetailProject = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/project/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setProjectDetail(data?.value)
          setInvoiceList(data?.value?.invoices)
          let tempExpenseList = data?.value?.expenses || []
          tempExpenseList = tempExpenseList.map((item, index) => {
            return {
              ...item,
              category_name: item?.category?.name || "-",
              project_name: item?.project?.name || "-",
            }
          }) || []
          setExpenseList(tempExpenseList)
          setEmployees(data?.value?.employee_assignments)

          if (data?.value?.payment_tempo) {
            setPaymentTempoValue({
              label: data?.value?.payment_tempo,
              value: data?.value?.payment_tempo
            })
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const fetchAllClient = (queries) => {
    let url = `/api/tracker/v1/client`
    if (queries) {
      url += `?${queries}`
    }
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url,
    })
      .then(({ data }) => {
        if (data?.success) {
          setClientOptions(singleClientsOptionsSelect(data.value))
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const fetchAllPicClient = (clientId) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/client/pic/options/${clientId}`,
    })
      .then(({ data }) => {
        const { success, value } = data || {}
        if (success) {
          setPicList(value)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleQueriesInvoice = () => {
    let queries = {
      search: searchInvoiceListFilter,
      limit: invoiceListPerPage,
      offset: invoiceListPerPage * activeInvoiceListPage - invoiceListPerPage,
      sort:
        (columnInvoiceListSorter &&
          `${columnInvoiceListSorter.column}%${columnInvoiceListSorter.state}`) ||
        "",
      project_id: id
    };
    queries = formUrlQuery(queries);

    return queries
  }

  const fetchAllInvoice = (queries) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/invoice?${queries}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          let invoices = data?.value || []
          invoices = invoices.map((invoice) => ({
            ...invoice,
            client_name: invoice?.client?.name || '-',
            status_invoice: invoice?.is_draft ? 'Draft' : 'Published',
          })) || []
          setInvoiceList(invoices)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleQueriesExpense = () => {
    let queries = {
      search: searchExpenseListFilter,
      limit: expenseListPerPage,
      offset: expenseListPerPage * activeExpenseListPage - expenseListPerPage,
      sort:
        (columnExpenseListSorter &&
          `${columnExpenseListSorter.column}%${columnExpenseListSorter.state}`) ||
        "",
      project_id: id
    };
    if (columnExpenseFilter) {
      Object.keys(columnExpenseFilter).forEach((key) => {
        if (columnExpenseFilter[key]) {
          queries[key] = columnExpenseFilter[key].value
        } else {
          queries[key] = ''
        }
      })
    }
    queries = formUrlQuery(queries);

    return queries
  }

  const fetchAllExpense = (queries) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/tracker/v1/expense?${queries}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          let tempExpenseList = data?.value || []
          tempExpenseList = tempExpenseList.map((item, index) => {
            return {
              ...item,
              category_name: item?.category?.name || "-",
              project_name: item?.project?.name || "-",
            }
          }) || []
          setExpenseList(tempExpenseList)
          if (activeExpenseListPage === 1) {
            setExpenseListCount(data?.count);
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const fetchAllCountries = () => {
    Axios({
      method: "get",
      url: "/api/tracker/v1/countries",
    })
      .then(({ data }) => {
        setCountryOptions(singleCountriesOptionsSelect(data))
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const fetchAllEmployee = () => {
    Axios({
      method: "get",
      url: "/api/tracker/v1/employee/option/list",
    })
      .then(({ data }) => {
        setEmployeeOptions(singleEmployeesOptionsSelect(data?.value))
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const fetchAllExpenseCategories = () => {
    Axios({
      method: "get",
      url: "/api/tracker/v1/expense/category/option/list",
    })
      .then(({ data }) => {
        if (data?.success) {
          setExpenseCategoryOptions(singleExpenseCategoryOptionsSelect(data.value))
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const fetchAllExpenseTags = () => {
    Axios({
      method: "get",
      url: "/api/tracker/v1/expense/tags/option/list",
    })
      .then(({ data }) => {
        if (data?.success) {
          setExpenseTagsOptions(singleExpenseTagsOptionsSelect(data.value))
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const fetchAllProvince = () => {
    Axios({
      method: "get",
      url: "/api/tracker/v1/countries/provinces",
    })
      .then(({ data }) => {
        if (data) {
          let finalProvinceOptions = data;
          finalProvinceOptions = finalProvinceOptions.map((prov) => {
            let objProv = {
              label: prov.province_name,
              value: prov.province_id,
            };
            return objProv;
          });
          setProvinceOptions(finalProvinceOptions);
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const fetchAllCities = (provinceId) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/countries/cities/${provinceId}`,
    })
      .then(({ data }) => {
        if (data) {
          let finalCityOptions = data;
          finalCityOptions = finalCityOptions.map((city) => {
            let objCity = {
              label: city.city_name,
              value: city.city_id,
            };
            return objCity;
          });
          setCityOptions(finalCityOptions);
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleSearchItemsInvoice = (search) => {
    setActiveInvoiceListPage(1)
    setSearchInvoiceListFilter(search);
  }

  const handleSearchItemsExpense = (search) => {
    setActiveExpenseListPage(1)
    setSearchExpenseListFilter(search);
  }

  const handleOnDateChange = (date, name) => {
    const formattedDate = date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : '';
    if (name?.includes('invoice')) {
      formikInvoice.setValues((values) => ({
        ...values,
        [name]: formattedDate
      }), false)
    } else if (name?.includes('expense')) {
      formikExpense.setValues((values) => ({
        ...values,
        [name]: formattedDate
      }), false)
    } else {
      formik.setValues((values) => ({
        ...values,
        [name]: formattedDate
      }), false)
    }
  }

  const handleInputValue = (values) => {
    const formData = new FormData()
    formData.append('name', values.project_name)
    formData.append('description', values.project_description)
    formData.append('value', parseFloat(values.project_value?.replace(/,/g, "")))
    formData.append('tax_value', parseFloat(values.project_tax_value?.replace(/,/g, "")))
    formData.append('start_date', values.project_start_date)
    formData.append('end_date', values.project_end_date)
    formData.append('client_id', values.client_value.value)
    formData.append('payment_tempo', values.project_payment_tempo)
    formData.append('other_payment_tempo', values.project_other_payment_tempo)
    formData.append('status', values.project_progress_status)
    formData.append('terms_invoice', values.terms_invoice)
    formData.append('terms_bast', values.terms_bast)
    formData.append('terms_po', values.terms_po)
    formData.append('terms_faktur_pajak', values.terms_faktur_pajak)
    formData.append('terms_pkp', values.terms_pkp)
    formData.append('terms_npwp', values.terms_npwp)
    formData.append('terms_progress_report', values.terms_progress_report)
    if (values?.terms_additional_info) {
      formData.append('terms_additional_info', values.terms_additional_info)
    }
    if (values?.project_contracts?.length > 0) {
      for (let i = 0; i < values.project_contracts.length; i++) {
        if (!values?.project_contracts[i]?.file_url && values?.project_contracts[i] instanceof File) {
          formData.append('contract', values.project_contracts[i])
        }
      }
    }
    if (values?.project_supporting_files?.length > 0) {
      for (let i = 0; i < values.project_supporting_files.length; i++) {
        if (!values?.project_supporting_files[i]?.file_url && values?.project_supporting_files[i] instanceof File) {
          formData.append('supporting_file', values.project_supporting_files[i])
        }
      }
    }
    if (values?.is_purchase_order == true && values?.project_purchase_orders?.length > 0) {
      for (let i = 0; i < values.project_purchase_orders.length; i++) {
        let purchesOrder = values.project_purchase_orders[i]
        if (!values?.project_purchase_orders[i]?.purchase_order_file[0].file_url && values?.project_purchase_orders[i].purchase_order_file[0] instanceof File) {
          formData.append('purchase_order_attachment', values.project_purchase_orders[i].purchase_order_file[0])
          purchesOrder.is_edit_attachment = true
        } else {
          purchesOrder.is_edit_attachment = false
        }
        formData.append('purchase_orders', JSON.stringify(purchesOrder))
      }
    }
    if (values?.project_employees?.length > 0) {
      formData.append('employees', JSON.stringify(values.project_employees))
    }
    if (values?.project_terms?.length > 0) {
      formData.append('terms', JSON.stringify(values.project_terms))
    }

    return formData
  }

  const handleInputValueSupportingLink = (values) => {
    const data = {
      file_url: values?.file_url,
      file_name: values?.file_name,
      file_description: values?.file_description,
      project_id: id
    }

    return data
  }

  const handleInputValueInvoice = (values) => {
    const formData = new FormData()

    formData.append('name', values?.invoice_name)
    formData.append('description', values?.invoice_description)
    formData.append('value', parseFloat(values.invoice_value?.replace(/,/g, "")))
    formData.append('tax_value', parseFloat(values.invoice_tax_value?.replace(/,/g, "")))
    formData.append('due_date', values?.invoice_due_date)
    formData.append('expected_payment_date', values?.invoice_expected_payment_date)
    formData.append('is_paid', values?.invoice_is_paid)
    formData.append('payment_date', values?.invoice_payment_date)
    formData.append('tax_due_date', values?.invoice_tax_due_date)
    formData.append('is_draft', values?.invoice_is_draft)
    if (values?.file?.length > 0) {
      for (let i = 0; i < values.file.length; i++) {
        if (!values?.file[i]?.file_url && values?.file[i] instanceof File) {
          formData.append('file', values.file[i])
        }
      }
    }
    formData.append('project_id', id)
    formData.append('bupot_required', values?.invoice_bupot_required)
    if (values?.file_bupot?.length > 0) {
      for (let i = 0; i < values.file.length; i++) {
        formData.append('file_bupot', values.file_bupot[i])
      }
    }
    formData.append('faktur_required', values?.invoice_faktur_required)
    if (values?.file_faktur?.length > 0) {
      for (let i = 0; i < values.file.length; i++) {
        formData.append('file_faktur', values.file_faktur[i])
      }
    }
    if (values.recipients.length > 0) {
      formData.append('recipients', JSON.stringify(values.recipients))
    }
    if (values?.client_value?.value) {
      formData.append('client_id', values?.client_value?.value)
    }
    let dataShippingDetail = {
      is_soft_copy: false,
      is_hard_copy: false,
      recipient: null,
      email_to: null,
      email_date: null,
      tracking_no: null,
      courier: null,
      shipping_date: null,
    }
    if (values.invoice_shipping_detail.is_soft_copy) {
      dataShippingDetail = {
        ...dataShippingDetail,
        is_soft_copy: true,
        recipient: values.invoice_shipping_detail?.recipient,
        email_to: values.invoice_shipping_detail?.email_to,
        email_date: values.invoice_shipping_detail?.email_date
      }
    }
    if (values.invoice_shipping_detail.is_hard_copy) {
      dataShippingDetail = {
        ...dataShippingDetail,
        is_hard_copy: true,
        tracking_no: values.invoice_shipping_detail?.tracking_no,
        courier: values.invoice_shipping_detail.courier?.value,
        shipping_date: values.invoice_shipping_detail?.shipping_date
      }
    }
    if (Object.keys(dataShippingDetail)?.length > 0) {
      formData.append('shipping_detail', JSON.stringify(dataShippingDetail))
    }
    if (values?.file_shipping?.length > 0) {
      for (let i = 0; i < values.file_shipping.length; i++) {
        if (!values?.file_shipping[i]?.file_url && values?.file_shipping[i] instanceof File) {
          formData.append('file_shipping', values.file_shipping[i])
        }
      }
    }

    return formData
  }

  const handleInputValueExpense = (values) => {
    const formData = new FormData()

    formData.append('name', values?.expense_name)
    formData.append('description', values?.expense_description)
    formData.append('value', parseFloat(values.expense_value?.replace(/,/g, "")))
    if (values?.expense_repeat_interval == 'no repeat') {
      formData.append('date', values?.expense_date)
    } else {
      formData.append('repeat_start_date', values?.expense_repeat_start_date)
      formData.append('repeat_end_date', values?.expense_repeat_end_date)
    }
    formData.append('repeat_forever', values?.expense_repeat_forever)
    formData.append('repeat_interval', values?.expense_repeat_interval)
    formData.append('notes', values?.expense_notes)
    if (values.file?.length > 0) {
      formData.append('file', values?.file[0])
    }
    formData.append('project_id', id)
    formData.append('is_update_all', false)
    if (values?.category_id) {
      let type = values?.category_value?.label
      formData.append('category_type', values?.category_value?.label)
      formData.append('category_id', values?.category_id)

      switch (type) {
        case 'Flight':
          if (values?.expense_flight) {
            formData.append('flight', JSON.stringify(values?.expense_flight))
          }
          break;
        case 'Accomodation':
          if (values?.expense_accomodation) {
            formData.append('accomodation', JSON.stringify(values?.expense_accomodation))
          }
          break;
        case 'Train':
          if (values?.expense_train) {
            formData.append('train', JSON.stringify(values?.expense_train))
          }
          break;
        case 'Car rental':
          if (values?.expense_car_rental) {
            formData.append('car_rental', JSON.stringify(values?.expense_car_rental))
          }
          break;
        case 'Pettycash & Operational':
          if (values?.expense_pettycash_operational) {
            formData.append('pettycash_operational', JSON.stringify(values?.expense_pettycash_operational))
          }
          break;
        case 'Meals':
          if (values?.expense_meals) {
            formData.append('meals', JSON.stringify(values?.expense_meals))
          }
          break;
        case 'Fuel':
          if (values?.expense_fuel) {
            formData.append('fuel', JSON.stringify(values?.expense_fuel))
          }
          break;
        case 'E-toll money':
          if (values?.expense_etoll) {
            formData.append('etoll_money', JSON.stringify(values?.expense_etoll))
          }
          break;
        case 'Transportation':
          if (values?.expense_transportation) {
            formData.append('transportation', JSON.stringify(values?.expense_transportation))
          }
          break;
        case 'Office supply / stationery':
          if (values?.expense_office_supplies) {
            formData.append('office_supply', JSON.stringify(values?.expense_office_supplies))
          }
          break;
        case 'Printing':
          if (values?.expense_printing) {
            formData.append('printing', JSON.stringify(values?.expense_printing))
          }
          break;
        case 'Other reimbursement':
          if (values?.expense_other_reimbursement) {
            formData.append('other_reimbursement', JSON.stringify(values?.expense_other_reimbursement))
          }
          break;
        default:
          break;
      }
    }

    return formData
  }

  const handlePost = (payload) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "post",
      url: `/api/tracker/v1/project/update/${id}`,
      data: payload
    })
      .then(({ data }) => {
        if (data?.success) {
          showSuccess('Project has been successfully updated')
          navigate(`/project/details/${id}`)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handlePostSupportingLink = (payload) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    let url = ''
    if (supportingLinkDetail?.id) {
      url = `/api/tracker/v1/project/update/projectsupportingdocs/${supportingLinkDetail?.id}`
    } else {
      url = `/api/tracker/v1/project/create/projectsupportingdocs`
    }

    Axios({
      method: "post",
      url,
      data: payload
    })
      .then(({ data }) => {
        if (data?.success) {
          fetchDetailProject()
          setShowModalAddSupportingLinks({ show: false, item: {} })
          setShowConfirmEdit({ show: false, type: '', item: {} })
          showSuccess(`Supporting link has been successfully ${supportingLinkDetail?.id ? 'updated' : 'added'}`)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handlePostInvoice = (payload) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    let url = ''
    let isCreateNewInvoice = false
    if (invoiceDetail?.id) {
      url = `/api/tracker/v1/invoice/update/${invoiceDetail?.id}`
    } else {
      url = `/api/tracker/v1/invoice/create`
      isCreateNewInvoice = true
    }

    Axios({
      method: "post",
      url,
      data: payload
    })
      .then(({ data }) => {
        const { success, value } = data || {}
        if (success) {
          if (isCreateNewInvoice) {
            Axios({
              method: "get",
              url: `/api/tracker/v1/invoice/generate-pdf/${value?.id}`,
            })
              .then(({ data }) => {
                const { success } = data || {}
                if (success) {
                  fetchAllInvoice(handleQueriesInvoice())
                  setShowConfirmAddInvoices({ show: false, item: {} })
                  setShowConfirmEdit({ show: false, type: '', item: {} })
                  formikInvoice.resetForm()
                  showSuccess('Invoice has been successfully created')
                }
              })
              .catch((err) => {
                console.error(err);
              })
              .finally(() => {
                dispatch({
                  type: 'SET_IS_LOADING',
                  isLoading: false
                })
              })
          } else {
            fetchAllInvoice(handleQueriesInvoice())
            setShowConfirmAddInvoices({ show: false, item: {} })
            setShowConfirmEdit({ show: false, type: '', item: {} })
            formikInvoice.resetForm()
            showSuccess('Invoice has been successfully updated')
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handlePostExpense = (payload) => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    let url = ''
    if (expenseDetail?.id) {
      if (showConfirmDuplicate?.show && showConfirmDuplicate.type == 'expense') {
        url = `/api/tracker/v1/expense/create`
      } else {
        url = `/api/tracker/v1/expense/update/${expenseDetail?.id}`
      }
    } else {
      url = `/api/tracker/v1/expense/create`
    }

    Axios({
      method: "post",
      url,
      data: payload
    })
      .then(({ data }) => {
        if (data?.success) {
          fetchAllExpense(handleQueriesExpense())
          setShowConfirmAddExpenses({ show: false, item: {} })
          setShowConfirmEdit({ show: false, type: '', item: {} })
          setShowConfirmDuplicate({ show: false, type: '', item: {} })
          showSuccess('Expense has been successfully saved')
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleSave = (values) => {
    const inputPayload = handleInputValue(values)
    handlePost(inputPayload)
  }

  const handleSaveSupportingLink = (values) => {
    const inputPayload = handleInputValueSupportingLink(values)
    handlePostSupportingLink(inputPayload)
  }

  const handleSaveInvoice = (values) => {
    const inputPayload = handleInputValueInvoice(values)
    handlePostInvoice(inputPayload)
  }

  const handleSaveExpense = (values) => {
    const inputPayload = handleInputValueExpense(values)
    handlePostExpense(inputPayload)
  }

  const handleSelectClient = (data) => {
    formik.setValues((values) => ({
      ...values,
      client_value: data
    }), false)

    if (data?.value) {
      fetchAllPicClient(data?.value)
    }
  }

  const handleSelectClientInvoice = (data) => {
    formikInvoice.setValues((values) => ({
      ...values,
      client_value: data
    }), false)
  }

  const handleSelectPic = (data) => {
    formik.setValues((values) => ({
      ...values,
      invoice_shipping_detail: {
        ...values.invoice_shipping_detail,
        ['recipient']: data ? data?.value : ''
      }
    }), false)
    
    setPicValue(data ? data : null)
  }

  const handleSelectExpenseCategory = (data) => {
    formikExpense.setFieldValue("category_id", data?.value);
    formikExpense.setFieldValue("category_value", data);

    setExpenseCategoryValue(data ? data : null)
  }

  const handleDelete = (name) => {
    let url = `/api/tracker/v1/`
    let itemName = ''
    if (name === 'invoices') {
      url += `invoice/delete/${showDeleteItem?.item?.id}`
      itemName = 'Invoice'
    }
    if (name === 'expenses') {
      url += `expense/delete/${showDeleteItem?.item?.id}`
      itemName = 'Expense'
    }
    if (name === 'supporting-link') {
      url += `project/delete/projectsupportingdocs/${showDeleteItem?.item?.id}`
      itemName = 'Supporting link'
    }

    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
      Axios({
        method: "delete",
        url,
      })
        .then(({ data }) => {
          if (data?.success) {
            fetchDetailProject()
            showSuccess(`${itemName} has been successfully deleted`)
            window.location.reload()
          }
        })
        .catch((err) => {
          console.error(err);
          const errMsg = err?.response?.data?.message
          showError(errMsg)
        })
        .finally(() => {
          dispatch({
            type: 'SET_IS_LOADING',
            isLoading: false
          })
        })
  }

  const handleRemoveFile = (index = 0, name) => {
    let prevNameField = name
    if (name === 'invoices' || name === 'expenses' || name === 'supporting-link') {
      handleDelete(name)
    } else {
      let selectFormik;
      if (
        name?.includes('invoice') ||
        name == 'file_shipping'
      ) {
        selectFormik = formikInvoice
        name = name?.includes('invoice') ? 'file' : name
      } else if (name?.includes('expense')) {
        selectFormik = formikExpense
        name = 'file'
      } else {
        if (name == 'purchase_order_file') {
          name = 'project_purchase_orders'
        }
        selectFormik = formik
      }
      let prevValue = selectFormik.values[name][index]
  
      let isDeleted = false
      let url = ''
  
      if (prevValue?.file_url || prevValue?.attachment_url) {
        if (name === 'project_contracts') {
          isDeleted = true
          url = `/api/tracker/v1/project/delete/projectcontract/${prevValue?.id}`  
        }
  
        if (name === 'project_supporting_files') {
          isDeleted = true
          url = `/api/tracker/v1/project/delete/projectsupportingfile/${prevValue?.id}`
        }

        if (prevNameField === 'invoice_attachments') {
          isDeleted = true
          url = `/api/tracker/v1/invoice/delete/invoiceattachment/${prevValue?.id}`
        }

        if (prevNameField === 'file_generate_pdf') {
          isDeleted = true
          url = `/api/tracker/v1/invoice/delete/invoicegeneratepdf/${prevValue?.id}`
        }

        if (name === 'file_shipping') {
          isDeleted = true
          url = `/api/tracker/v1/invoice/delete/shipping/${invoiceDetail?.id}`
        }
      }
  
      if (isDeleted) {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: true
        })
        Axios({
          method: "delete",
          url,
        })
          .then(({ data }) => {
            if (data?.success) {
              fetchDetailProject()
              showSuccess('File has been successfully deleted')
              window.location.reload()
            }
          })
          .catch((err) => {
            console.error(err);
            const errMsg = err?.response?.data?.message
            showError(errMsg)
          })
          .finally(() => {
            dispatch({
              type: 'SET_IS_LOADING',
              isLoading: false
            })
          })
      } else {
        if (name === 'project_purchase_orders') {
          let purchaseOrders = formik.values.project_purchase_orders || []
          purchaseOrders[index].purchase_order_file = []

          selectFormik.setValues((values) => ({
            ...values,
            project_purchase_orders: purchaseOrders
          }), false)
        } else {
          selectFormik.setValues((values) => ({
            ...values,
            [name]: values[name]?.filter((_, i) => i !== index)
          }), false)
        }
      }
    }

    setShowDeleteItem({ show: false, type: '', item: {}, index: 0 })
  }

  const handleFileInput = (values, type) => {
    const files = values

    if (files) {
      if (type?.includes('project')) {
        formik.setValues((prevValues) => ({
          ...prevValues,
          [type]: [...prevValues[type], ...files]
        }), false)        
      }

      if (
        type?.includes('invoice') ||
        type == 'file_shipping'
      ) {
        formikInvoice.setValues((prevValues) => ({
          ...prevValues,
          [type?.includes('invoice') ? 'file' : type]: type?.includes('invoice') ? [...prevValues['file'], ...files] : files
        }), false)
        setShowConfirmAddAttachments({ show: false, item: {} })
      }

      if (type?.includes('expense')) {
        formikExpense.setValues((prevValues) => ({
          ...prevValues,
          file: files
        }), false) 
      }

      if (type === 'project_contracts') {
        setShowConfirmAddContract({ show: false, item: {} })
      }

      if (type === 'project_supporting_files') {
        setShowConfirmAddOtherFiles({ show: false, item: {} })
      }
    }
  }

  const handleSelectStatusProjectContract = () => {
    const { item, value } = showConfirmChangeStatusContract
    const { id: contract_id } = item || {}
    const valueOpt = value?.value
    const payload = {
      is_signed: valueOpt
    }

    Axios({
      method: "post",
      url: `/api/tracker/v1/project/update/status/projectcontract/${contract_id}`,
      data: payload
    })
      .then(({ data }) => {
        if (data?.success) {
          fetchDetailProject()
          setShowConfirmChangeStatusContract({ show: false, item: {}, value: null })
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  const handleShowModalChangeStatusContract = ({ show, item, value }) => {
    if (item?.is_signed !== value?.value) {
      setShowConfirmChangeStatusContract({ show, item, value })
    }
  }

  const handleSelectExpenseInterval = (data) => {
    formikExpense.setValues((values) => ({
      ...values,
      expense_repeat_interval: data?.value,
      expense_repeat_start_date: data?.value == 'no repeat' ? '' : values.expense_repeat_start_date,
      expense_repeat_end_date: data?.value == 'no repeat' ? '' : values.expense_repeat_end_date,
      expense_date: data?.value == 'no repeat' ? values.expense_date : ''
    }), false)

    setIntervalValue(data)
  }

  const handleSwitchRepeatForever = (e) => {
    let interval = formikExpense.values.expense_repeat_interval
    
    if (
      formikExpense.values.expense_repeat_interval == 'no repeat' &&
      e.target.checked == true
    ) {
      interval = ''
      setIntervalValue(null)
    }

    formikExpense.setValues((prevValues) => ({
      ...prevValues,
      expense_repeat_forever: e.target.checked,
      expense_repeat_interval: interval
    }), false)
  }

  useEffect(() => {
    if (showConfirmEdit.show) {
      if (showConfirmEdit.type === 'invoice') {
        let invoiceValue = showConfirmEdit.item
        let recipientsValue = invoiceValue?.recipients || []
        if (recipientsValue.length > 0) {
          recipientsValue = recipientsValue?.map((e) => {
            const countryValue = typeof e?.country_value === 'string' ? JSON.parse(e?.country_value) : e?.country_value
            return {
              ...e,
              phone_number: e?.recipient_contact_number,
              country_id: e?.recipient_country_id,
              country_value: JSON.stringify({
                id: countryValue?.id,
                name: countryValue?.name,
                icon: icon[`cif${countryValue?.country_code}`],
                phone_code: countryValue?.phone_code
              })
            }
          })

          invoiceValue.recipients = recipientsValue
        }
        
        setInvoiceDetail(invoiceValue)

        if (invoiceValue?.client?.id) {
          fetchAllPicClient(invoiceValue?.client?.id)
        }

        setTimeout(() => {
          setShowConfirmAddInvoices({ show: true, item: {} })
          setHeaderTitle('Edit Project Invoice')
        }, 1000)
      }
      if (showConfirmEdit.type === 'expense') {
        let detail = showConfirmEdit.item
        if (detail?.category) {
          let categoryValue = {
            label: detail?.category?.name,
            value: detail?.category?.id
          }
          detail.category_value = categoryValue
          setExpenseCategoryValue(categoryValue)

          if (detail?.category?.name == 'Transportation') {
            setExpenseTransportationValue({
              label: detail?.transportation?.transportation_category,
              value: detail?.transportation?.transportation_category
            })
          }

          if (detail?.category?.name == 'Fuel') {
            setExpenseFuelValue({
              label: detail?.fuel?.company_name,
              value: detail?.fuel?.company_name
            })
          }

          if (detail?.category?.name == 'Flight') {
            setExpenseFlightValue({
              label: detail?.flight?.booking_through,
              value: detail?.flight?.booking_through
            })

            setExpenseAirplaneValue({
              label: detail?.flight?.airplane_name,
              value: detail?.flight?.airplane_name
            })
          }

          if (detail?.category?.name == 'Train') {
            setExpenseTrainValue({
              label: detail?.train?.booking_through,
              value: detail?.train?.booking_through
            })
          }

          if (detail?.category?.name == 'Accomodation') {
            setExpenseAccomodationValue({
              label: detail?.accomodation?.booking_through,
              value: detail?.accomodation?.booking_through
            })

            if (detail?.accomodation?.province_id) {
              setExpenseAccomodationProvinceValue({
                label: detail?.accomodation?.province?.label,
                value: detail?.accomodation?.province?.value
              })
              fetchAllCities(detail?.accomodation?.province?.value)
            }
            
            if (detail?.accomodation?.city_id) {
              setExpenseAccomodationCitiesValue({
                label: detail?.accomodation?.city?.label,
                value: detail?.accomodation?.city?.value
              })
            }
          }
        }
        setExpenseDetail(detail)
        setShowConfirmAddExpenses({ show: true, item: {} })
        setHeaderTitle('Edit Project Expense')
      }
      if (showConfirmEdit.type === 'supporting-link') {
        setSupportingLinkDetail(showConfirmEdit.item)
        setShowModalAddSupportingLinks({ show: true, item: {} })
        setHeaderTitle('Edit Project Supporting Links')
      }
    }
  }, [showConfirmEdit])

  useEffect(() => {
    if (showConfirmDuplicate.show) {
      if (showConfirmDuplicate.type === 'expense') {
        let detail = showConfirmDuplicate.item
        if (detail?.category) {
          let categoryValue = {
            label: detail?.category?.name,
            value: detail?.category?.id
          }
          detail.category_value = categoryValue
          setExpenseCategoryValue(categoryValue)

          if (detail?.category?.name == 'Transportation') {
            setExpenseTransportationValue({
              label: detail?.transportation?.transportation_category,
              value: detail?.transportation?.transportation_category
            })
          }

          if (detail?.category?.name == 'Fuel') {
            setExpenseFuelValue({
              label: detail?.fuel?.company_name,
              value: detail?.fuel?.company_name
            })
          }

          if (detail?.category?.name == 'Flight') {
            setExpenseFlightValue({
              label: detail?.flight?.booking_through,
              value: detail?.flight?.booking_through
            })

            setExpenseAirplaneValue({
              label: detail?.flight?.airplane_name,
              value: detail?.flight?.airplane_name
            })
          }

          if (detail?.category?.name == 'Train') {
            setExpenseTrainValue({
              label: detail?.train?.booking_through,
              value: detail?.train?.booking_through
            })
          }

          if (detail?.category?.name == 'Accomodation') {
            setExpenseAccomodationValue({
              label: detail?.accomodation?.booking_through,
              value: detail?.accomodation?.booking_through
            })

            if (detail?.accomodation?.province_id) {
              setExpenseAccomodationProvinceValue({
                label: detail?.accomodation?.province?.label,
                value: detail?.accomodation?.province?.value
              })
              fetchAllCities(detail?.accomodation?.province?.value)
            }
            
            if (detail?.accomodation?.city_id) {
              setExpenseAccomodationCitiesValue({
                label: detail?.accomodation?.city?.label,
                value: detail?.accomodation?.city?.value
              })
            }
          }
        }
        setExpenseDetail(detail)
        setShowConfirmAddExpenses({ show: true, item: {} })
        setHeaderTitle('Duplicate Project Expense')
      }
    }
  }, [showConfirmDuplicate])

  useEffect(() => {
    if (showConfirmView?.show) {
      if (showConfirmView?.type === 'invoice') {
        let invoiceValue = showConfirmView?.item
        let recipientsValue = invoiceValue?.recipients || []

        if (recipientsValue.length > 0) {
          recipientsValue = recipientsValue?.map((e) => {
            let newValue = {
              ...e,
              phone_number: e?.recipient_contact_number,
              country_id: e?.recipient_country_id,
            }

            if (e?.country_value?.id) {
              newValue.country_value = JSON.stringify({
                id: e?.country_value?.id,
                name: e?.country_value?.name,
                icon: icon[`cif${e?.country_value?.country_code}`],
                phone_code: e?.country_value?.phone_code
              })
            }

            return newValue
          })

          invoiceValue.recipients = recipientsValue
        }

        setInvoiceDetail(invoiceValue)
      }
      if (showConfirmView?.type === 'expense') {
        setExpenseDetail(showConfirmView.item)
      }
      if (showConfirmView?.type === 'supporting-link') {
        setSupportingLinkDetail(showConfirmView.item)
      }
    }
  }, [showConfirmView])

  useEffect(() => {
    if (!showConfirmAddInvoices.show) {
      setInvoiceDetail('')
    }
    if (!showConfirmAddExpenses.show) {
      setExpenseDetail('')
    }
    if (!showModalAddSupportingLinks.show) {
      setSupportingLinkDetail('')
    }
  }, [showConfirmAddInvoices, showConfirmAddExpenses, showModalAddSupportingLinks])

  const handleUploadNewContracts = () => {
    setShowConfirmAddContract({ show: true, item: {} })
  }

  const handleUploadNewOtherFiles = () => {
    setShowConfirmAddOtherFiles({ show: true, item: {} })
  }

  const handleUploadNewSupportingLinks = () => {
    setShowModalAddSupportingLinks({ show: true, item: {} })
    setHeaderTitle('Add Project Supporting Links')
    setSupportingLinkDetail('')
  }

  const handleShowModalCreateNewInvoice = () => {
    setShowConfirmAddInvoices({ show: true, item: {} })
    setHeaderTitle('Add Project Invoice')
    setInvoiceDetail('')
    formikInvoice.resetForm()
  }

  const handleShowModalCreateNewExpense = () => {
    setShowConfirmAddExpenses({ show: true, item: {} })
    setHeaderTitle('Add Project Expense')
  }

  const handleSubmit = () => {
    formik.handleSubmit()

    setShowModalConfirm({ show: false })
  }

  const handleCardHeaderButton = () => {
    setShowConfirmAddAttachments({ show: true, item: {} })
  }

  const handleAddInvoiceRecipients = () => {
    formikInvoice.setValues((values) => ({
      ...values,
      recipients: [
        ...values.recipients,
        ...[
          {
            recipient_name: null,
            phone_number: '',
            country_id: '',
            country_value: null,
            recipient_email: '',
          }
        ]
      ]
    }), false)
  }

  const handleChangeInvoiceRecipients = (e, informationIndex) => {
    const name = e?.target?.name
    const value = e?.target?.value

    formikInvoice.setValues((values) => {
      const newArrayInformation = values.recipients.map((item, itemIndex) => {
        if (itemIndex == informationIndex) {
          return {
            ...item,
            [name]: value
          };
        } else {
          return item;
        }
      });

      return {
        ...values,
        recipients: [
          ...newArrayInformation,
        ]
      }
    }, false)
  }

  const handleSelectCountryInvoiceRecipients = (data, informationIndex) => {
    let edataCountryValue = {
      target: {
        name: 'country_value',
        value: data?.value
      }
    }
    handleChangeInvoiceRecipients(edataCountryValue, informationIndex)
  }

  const handleRemoveInvoiceRecipients = (_, index) => {
    formikInvoice.setValues((values) => ({
      ...values,
      recipients: values.recipients.filter((_, itemIndex) => itemIndex !== index)
    }), false)
  }

  const handleAddPurchaseOrders = () => {
    formik.setValues((values) => ({
      ...values,
      project_purchase_orders: [
        ...values.project_purchase_orders,
        ...[
          {
            order_number: '',
            order_value: '',
            order_created: '',
            order_notes: '',
            purchase_order_file: []
          }
        ]
      ]
    }), false)
  }

  const handleChangePurchaseOrders = (e, informationIndex, type) => {
    let name = e?.target?.name
    if (!name) {
      if (!type) {
        name = 'order_created'
      } else {
        name = type
      }
    }
    let value = e?.target?.value
    if (!value) {
      value = e
    }

    formik.setValues((values) => {
      const newArrayInformation = values.project_purchase_orders.map((item, itemIndex) => {
        if (itemIndex == informationIndex) {
          return {
            ...item,
            [name]: name === 'order_created' ? moment(value).format('YYYY-MM-DD HH:mm:ss') : value
          };
        } else {
          return item;
        }
      });

      return {
        ...values,
        project_purchase_orders: [
          ...newArrayInformation,
        ]
      }
    }, false)
  }

  const handleRemovePurchaseOrders = (_, index) => {
    formik.setValues((values) => ({
      ...values,
      project_purchase_orders: values.project_purchase_orders.filter((_, itemIndex) => itemIndex !== index)
    }), false)
  }

  const handleSelectPaymentTempo = (data) => {
    formik.setValues((values) => ({
      ...values,
      project_payment_tempo: data?.value
    }), false)

    setPaymentTempoValue(data ? data : null)
  }

  const handleAddProjectTerms = () => {
    formik.setValues((values) => ({
      ...values,
      project_terms: [
        ...values.project_terms,
        ...[
          {
            term_name: '',
            term_percentage: '',
            term_value: '',
            term_tax_value: ''
          }
        ]
      ]
    }), false)
  }

  const handleChangeProjectTerms = (e, informationIndex) => {
    let name = e?.target?.name
    let value = e?.target?.value

    formik.setValues((values) => {
      const newArrayInformation = values.project_terms.map((item, itemIndex) => {
        if (itemIndex == informationIndex) {
          return {
            ...item,
            [name]: value
          };
        } else {
          return item;
        }
      });

      return {
        ...values,
        project_terms: [
          ...newArrayInformation,
        ]
      }
    }, false)
  }

  const handleRemoveProjectTerms = (_, index) => {
    formik.setValues((values) => ({
      ...values,
      project_terms: values.project_terms.filter((_, itemIndex) => itemIndex !== index)
    }), false)
  }

  const handleSelectProgressStatus = (data) => {
    formik.setValues((values) => ({
      ...values,
      project_progress_status: data?.value
    }), false)
  }

  const handleOnRowInvoiceClick = (item, columnName) => {
    if (columnName !== 'action') {
      setShowConfirmView({ show: true, type: 'invoice', item })
    }
  }

  const handleOnRowExpenseClick = (item, columnName) => {
    if (columnName !== 'action') {
      setShowConfirmView({ show: true, type: 'expense', item })
    }
  }

  const handleOnRowSuppLinkClick = (item, columnName) => {
    if (columnName !== 'action') {
      setShowConfirmView({ show: true, type: 'supporting-link', item })
    }
  }

  const handleSelectEmployee = (data) => {
    formik.setValues((values) => ({
      ...values,
      project_employees: data ? data : []
    }), false)

    setEmployees(data ? data : [])
  }

  const handleSearchClient = (e) => {
    setSearchClientListFilter(e)
  }

  const handleCheckbox = (e) => {
    const isChecked = e.target.checked
    const name = e.target.name
    formikInvoice.setValues((values) => ({
      ...values,
      invoice_shipping_detail: {
        ...values.invoice_shipping_detail,
        [name]: isChecked
      }
    }), false)
  }

  const handleChangeShippingDetail = (e) => {
    const value = e.target.value
    const name = e.target.name
    formikInvoice.setValues((values) => ({
      ...values,
      invoice_shipping_detail: {
        ...values.invoice_shipping_detail,
        [name]: value
      }
    }), false)
  }

  const handleDateChangeShippingDetail = (date, name) => {
    formikInvoice.setValues((values) => ({
      ...values,
      invoice_shipping_detail: {
        ...values.invoice_shipping_detail,
        [name]: date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : ''
      }
    }), false)
  }

  const handleSelectCourier = (data) => {
    formikInvoice.setValues((values) => ({
      ...values,
      invoice_shipping_detail: {
        ...values.invoice_shipping_detail,
        ['courier']: data
      }
    }), false)
  }

  const handleChangeFieldCategory = (e, category) => {
    const name = e?.target?.name
    const value = e?.target?.value
    const checked = e?.target?.checked

    formikExpense.setValues((values) => ({
      ...values,
      [category]: {
        ...values[category],
        [name]: name == 'is_booking_more_than_one_day' ? checked : value
      }
    }), false)
  }

  const handleOnDateChangeCategory = (date, name, category) => {
    formikExpense.setValues((values) => ({
      ...values,
      [category]: {
        ...values[category],
        [name]: date ? moment(date).format('YYYY-MM-DD HH:mm:ss') : ''
      }
    }), false)
  }

  const handleSelectOptionExpenseCategory = (data, name, category, isMultiple) => {
    formikExpense.setValues((values) => ({
      ...values,
      [category]: {
        ...values[category],
        [name]: isMultiple ? data?.length > 0 ? data?.map((val) => {
          return {
            label: val?.label,
            value: val?.value
          }
        }) : [] : data ? data?.value : null
      }
    }), false)

    if (category == 'expense_flight') {
      if (name == 'booking_through') {
        setExpenseFlightValue(data)
      }
      if (name == 'airplane_name') {
        setExpenseAirplaneValue(data)
      }
    }

    if (category == 'expense_train') {
      if (name == 'booking_through') {
        setExpenseTrainValue(data)
      }
    }

    if (category == 'expense_transportation') {
      setExpenseTransportationValue(data)
    }

    if (category == 'expense_fuel') {
      setExpenseFuelValue(data)
    }

    if (category == 'expense_accomodation') {
      if (name == 'booking_through') {
        setExpenseAccomodationValue(data)
      }
      if (name == 'accomodation_province_id') {
        fetchAllCities(data?.value)
        setExpenseAccomodationProvinceValue(data)
      }
      if (name == 'accomodation_city_id') {
        setExpenseAccomodationCitiesValue(data)
      }
    }
  }

  const handleChangePassenger = (e, index, category) => {
    const name = e?.target?.name;
    const value = e?.target?.value;

    const path = `${category}.passengers[${index}].[${name}]`;
    
    formikExpense.setFieldValue(path, value, false);
  };

  const handleAddPassenger = (category) => {
    formikExpense.setValues((values) => ({
      ...values,
      [category]: {
        ...values[category],
        [category == 'expense_accomodation' ? 'guests' : 'passengers']: [
          ...values[category]?.[category == 'expense_accomodation' ? 'guests' : 'passengers'],
          ...[
            {
              first_name: '',
              last_name: ''
            }
          ]
        ]
      }
    }), false)
  }

  const handleRemovePassenger = (index, category) => {
    formikExpense.setValues((values) => ({
      ...values,
      [category]: {
        ...values[category],
        [category == 'expense_accomodation' ? 'guests' : 'passengers']: values[category]?.[category == 'expense_accomodation' ? 'guests' : 'passengers']?.filter((_, itemIndex) => itemIndex !== index)
      }
    }), false)
  }

  const handleCheckboxInvoicingTermsCondition = (e) => {
    const isChecked = e.target.checked
    const name = e.target.name
    formik.setValues((values) => ({
      ...values,
      [name]: isChecked
    }), false)
  }

  return (
    <>
      {openFilePreview && (
        <AppModalFilePreview
          setOpenFilePreview={setOpenFilePreview}
          file={openFilePreview}
        />
      )}
      {
        showConfirmAddAttachments.show && (
          <AppModalConfirmation 
            confirmationType='add-attachments'
            itemName='invoice_attachments'
            itemDetails={showConfirmAddAttachments.item}
            showModal={showConfirmAddAttachments}
            setShowModal={setShowConfirmAddAttachments}
            errors={formikInvoice.errors?.file}
            handleChange={formikInvoice.handleChange}
            handleFileInput={handleFileInput}
            headerTitle={`Add Invoice Attachments`}
            values={formikInvoice.values}
          />
        )
      }
      {
        showConfirmAddContract.show && (
          <AppModalConfirmation 
            confirmationType='add-contract'
            itemName='project_contracts'
            itemDetails={showConfirmAddContract.item}
            showModal={showConfirmAddContract}
            setShowModal={setShowConfirmAddContract}
            errors={formik.errors?.project_contracts}
            handleChange={formik.handleChange}
            handleFileInput={handleFileInput}
            headerTitle={`Add Project Contracts`}
          />
        )
      }
      {
        showConfirmAddOtherFiles.show && (
          <AppModalConfirmation 
            confirmationType='add-other-files'
            itemName='project_supporting_files'
            itemDetails={showConfirmAddOtherFiles.item}
            showModal={showConfirmAddOtherFiles}
            setShowModal={setShowConfirmAddOtherFiles}
            errors={formik.errors?.project_supporting_files}
            handleChange={formik.handleChange}
            handleFileInput={handleFileInput}
            headerTitle={`Add Project Supporting Files`}
          />
        )
      }
      {
        showModalAddSupportingLinks.show && (
          <AppModalConfirmation 
            confirmationType='add-supporting-links'
            itemName='project_supporting_docs'
            itemDetails={showModalAddSupportingLinks.item}
            showModal={showModalAddSupportingLinks}
            setShowModal={setShowModalAddSupportingLinks}
            values={formikSupportingLink.values}
            errors={formikSupportingLink.errors}
            handleChange={formikSupportingLink.handleChange}
            headerTitle={headerTitle}
            handleSubmit={() => formikSupportingLink.handleSubmit()}
          />
        )
      }
      {
        showConfirmAddInvoices.show && (
          <AppModalConfirmation 
            confirmationType='add-invoices'
            itemName='add-invoices'
            headerTitle={headerTitle}
            showModal={showConfirmAddInvoices}
            setShowModal={setShowConfirmAddInvoices}
            values={formikInvoice.values}
            errors={formikInvoice.errors}
            handleChange={formikInvoice.handleChange}
            handleFileInput={handleFileInput}
            handleOnDateChange={handleOnDateChange}
            handleSubmit={() => formikInvoice.handleSubmit()}
            handleConfirmDelete={setShowDeleteItem}
            isLoading={isLoading}
            handleCardHeaderButton={handleCardHeaderButton}
            handleViewFile={setOpenFilePreview}
            handleAddInvoiceRecipients={handleAddInvoiceRecipients}
            handleChangeInvoiceRecipients={handleChangeInvoiceRecipients}
            handleSelectCountryInvoiceRecipients={handleSelectCountryInvoiceRecipients}
            handleRemoveInvoiceRecipients={handleRemoveInvoiceRecipients}
            countryOptions={countryOptions}
            clientOptions={clientOptions}
            handleSelectClient={handleSelectClientInvoice}
            handleSearchInput={handleSearchClient}
            handleCheckbox={handleCheckbox}
            handleChangeShippingDetail={handleChangeShippingDetail}
            handleDateChangeShippingDetail={handleDateChangeShippingDetail}
            courierOptions={singleCourierOptionSelect()}
            handleSelectCourier={handleSelectCourier}
            handleSelectPic={handleSelectPic}
            picList={picList}
            picValue={picValue}
          />
        )
      }
      {
        showConfirmAddExpenses.show && (
          <AppModalConfirmation 
            confirmationType='add-expenses'
            itemName='add-expenses'
            headerTitle={headerTitle}
            itemDetails={showConfirmAddExpenses.item}
            showModal={showConfirmAddExpenses}
            setShowModal={setShowConfirmAddExpenses}
            values={formikExpense.values}
            errors={formikExpense.errors}
            handleChange={formikExpense.handleChange}
            handleFileInput={handleFileInput}
            handleOnDateChange={handleOnDateChange}
            handleSubmit={() => formikExpense.handleSubmit()}
            handleConfirmDelete={setShowDeleteItem}
            handleSelectInterval={handleSelectExpenseInterval}
            handleSwitchRepeatForever={handleSwitchRepeatForever}
            intervalValue={intervalValue}
            expenseIntervalOptions={singleExpenseIntervalOptionSelect(formikExpense.values.expense_repeat_forever)}
            expenseCategoryOptions={expenseCategoryOptions}
            expenseCategoryValue={expenseCategoryValue}
            expenseTagsOptions={expenseTagsOptions}
            handleSelectExpenseCategory={handleSelectExpenseCategory}
            handleChangeFieldCategory={handleChangeFieldCategory}
            handleOnDateChangeCategory={handleOnDateChangeCategory}
            expenseTransportationOptions={singleExpenseCategoryTransportOptionSelect()}
            expenseFuelOptions={singleExpenseCategoryFuelOptionSelect()}
            handleSelectOptionExpenseCategory={handleSelectOptionExpenseCategory}
            expenseTransportationValue={expenseTransportationValue}
            expenseFuelValue={expenseFuelValue}
            tripTypeOptions={singleExpenseCategoryTripTypeOptionSelect()}
            bookingThroughFlighOptions={singleExpenseCategoryFlightOptionSelect()}
            bookingThroughTrainOptions={singleExpenseCategoryTrainOptionSelect()}
            expenseFlightValue={expenseFlightValue}
            expenseTrainValue={expenseTrainValue}
            handleChangePassenger={handleChangePassenger}
            handleAddPassenger={handleAddPassenger}
            handleRemovePassenger={handleRemovePassenger}
            expenseAirplaneOptions={singleExpenseCategoryAirplaneOptionSelect()}
            expenseAirplaneValue={expenseAirplaneValue}
            bookingThroughAccomodationOptions={singleExpenseCategoryAccomodationOptionSelect()}
            expenseAccomodationValue={expenseAccomodationValue}
            provinceOptions={provinceOptions}
            cityOptions={cityOptions}
            expenseAccomodationProvinceValue={expenseAccomodationProvinceValue}
            expenseAccomodationCitiesValue={expenseAccomodationCitiesValue}
          />
        )
      }
      {
        showConfirmView.show && showConfirmView?.type === 'supporting-link' && (
          <AppModalConfirmation 
            confirmationType='detail-supporting-link'
            itemName="detail-supporting-link"
            itemDetails={showConfirmView.item}
            itemType={showConfirmView.type}
            showModal={showConfirmView}
            setShowModal={setShowConfirmView}
          />
        )
      }
      {
        showConfirmView.show && showConfirmView?.type === 'invoice' && (
          <AppModalConfirmation 
            confirmationType='detail-invoice'
            itemName="detail-invoice"
            itemDetails={invoiceDetail}
            itemType={showConfirmView.type}
            showModal={showConfirmView}
            setShowModal={setShowConfirmView}
            handleViewFile={setOpenFilePreview}
          />
        )
      }
      {
        showConfirmView.show && showConfirmView?.type === 'expense' && (
          <AppModalConfirmation 
            confirmationType='detail-expense'
            itemName="detail-expense"
            itemDetails={showConfirmView.item}
            itemType={showConfirmView.type}
            showModal={showConfirmView}
            setShowModal={setShowConfirmView}
            handleViewFile={setOpenFilePreview}
          />
        )
      }
      {
        showConfirmChangeStatusContract.show && (
          <AppModalConfirmation 
            confirmationType='change-status-contract'
            itemName="change-status-contract"
            itemDetails={showConfirmChangeStatusContract.item}
            itemType={showConfirmChangeStatusContract.value?.value}
            showModal={showConfirmChangeStatusContract}
            setShowModal={setShowConfirmChangeStatusContract}
            handleSubmit={handleSelectStatusProjectContract}
          />
        )
      }
      {
        showDeleteItem.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={`${showDeleteItem?.item?.file_original_name ? showDeleteItem?.item?.file_original_name : showDeleteItem?.item?.file_name ? showDeleteItem?.item?.file_name : showDeleteItem?.item?.name}`}
            itemDetails={showDeleteItem.item}
            itemType={showDeleteItem.type}
            itemIndex={showDeleteItem?.index}
            showModal={showDeleteItem}
            setShowModal={setShowDeleteItem}
            handleConfirmation={handleRemoveFile}
          />
        )
      }
      {
        showModalConfirm.show && (
          <AppModalConfirmation 
            confirmationType="confirmation"
            showModal={showModalConfirm}
            setShowModal={setShowModalConfirm}
            headerTitle="Confirmation"
            descriptionText="Are you sure want to edit this project?"
            handleSubmit={handleSubmit}
            disabled={formik.isSubmitting}
            isLoading={isLoading}
          />
        )
      }
      <AppCard 
        className='mb-4'
        headerTitle={<span className='fs-5 fs-md-4'>Edit Project</span>}
        bodyContent={
          <AppForm 
            values={formik.values}
            handleChange={formik.handleChange}
            errors={formik.errors}
            onDateChange={handleOnDateChange}
            clientOptions={clientOptions}
            setClient={setClient}
            client={client}
            handleSelectClient={handleSelectClient}
            handleSearchInput={handleSearchClient}
            handleAddPurchaseOrders={handleAddPurchaseOrders}
            handleChangeInvoiceRecipients={handleChangePurchaseOrders}
            handleRemovePurchaseOrders={handleRemovePurchaseOrders}
            setOpenFilePreview={setOpenFilePreview}
            handleConfirmDelete={setShowDeleteItem}
            handleSelectEmployee={handleSelectEmployee}
            employees={employees}
            employeeOptions={employeeOptions}
            handleAddProjectTerms={handleAddProjectTerms}
            handleChangeProjectTerms={handleChangeProjectTerms}
            handleRemoveProjectTerms={handleRemoveProjectTerms}
            handleSelectPaymentTempo={handleSelectPaymentTempo}
            paymentTempoOptions={singlePaymentTempoOptionSelect()}
            paymentTempoValue={paymentTempoValue}
            handleSelectProgressStatus={handleSelectProgressStatus}
            handleCheckbox={handleCheckboxInvoicingTermsCondition}
          />
        }
        lowerBodyContent={
          <>
            <AppCard
              className='mt-4 mb-4'
              headerTitle={
                <AppCardHeader
                  headerTitle={<span className='fs-6 fs-md-4'>Contracts</span>}
                  headerButton="Upload new"
                  handleCardHeaderButton={handleUploadNewContracts}
                />
              }
              bodyContent={
                <>
                  {
                    formik.values?.project_contracts?.length > 0 ? (
                      <FormFileThumbnail 
                        name='project_contracts'
                        colSize='3'
                        files={formik.values?.project_contracts}
                        className='justify-content-start align-items-center'
                        handleConfirmDelete={setShowDeleteItem}
                        handleViewFile={setOpenFilePreview}
                        isShowDropdown={true}
                        inputDropdownLabel='Status'
                        dropdownPlaceholder='status...'
                        dropdownName='project_contract'
                        selectOptions={singleStatusContractProjectOptionSelect()}
                        handleShowModal={handleShowModalChangeStatusContract}
                      />
                    )
                    : (
                      <>Not Found</>
                    )
                  }
                </>
              }
            />
            <AppCard
              className='mt-4 mb-4'
              headerTitle={
                <AppCardHeader
                  headerTitle={<span className='fs-6 fs-md-4'>Other supporting files</span>}
                  headerButton="Upload new"
                  handleCardHeaderButton={handleUploadNewOtherFiles}
                />
              }
              bodyContent={
                <>
                  {
                    formik.values?.project_supporting_files?.length > 0 ? (
                      <FormFileThumbnail 
                        name='project_supporting_files'
                        colSize='3'
                        files={formik.values?.project_supporting_files}
                        className='justify-content-start align-items-center'
                        handleConfirmDelete={setShowDeleteItem}
                        handleViewFile={setOpenFilePreview}
                      />
                    )
                    : (
                      <>Not Found</>
                    )
                  }
                </>
              }
            />
            <AppCard
              className='mt-4 mb-4'
              headerTitle={
                <AppCardHeader
                  headerTitle={<span className='fs-6 fs-md-4'>Supporting links</span>}
                  headerButton="Create new"
                  handleCardHeaderButton={handleUploadNewSupportingLinks}
                />
              }
              bodyContent={
                <AppTable
                  supportingLinksListPage
                  tableColumns={columnSupportingLinksList}
                  tableContent={formik.values.project_supporting_docs}
                  isShowPagination={false}
                  isShowModalEdit={true}
                  setShowConfirmEdit={setShowConfirmEdit}
                  setShowConfirmDelete={setShowDeleteItem}
                  handleOnRowClick={handleOnRowSuppLinkClick}
                  isClickable={true}
                />
              }
            />
            <AppCard
              className='mt-4 mb-4'
              headerTitle={
                <AppCardHeader
                  headerTitle={<span className='fs-6 fs-md-4'>Invoices</span>}
                  headerButton="Create new invoice"
                  handleCardHeaderButton={handleShowModalCreateNewInvoice}
                />
              }
              bodyContent={
                <AppTable
                  invoiceListPage
                  tableFilter
                  tableColumns={columnInvoiceList}
                  tableContent={invoiceList}
                  isShowModalEdit={true}
                  setShowConfirmEdit={setShowConfirmEdit}
                  setShowConfirmDelete={setShowDeleteItem}
                  setSearchContentFilter={handleSearchItemsInvoice}
                  setActiveContentPage={setActiveInvoiceListPage}
                  setContentPerPage={setInvoiceListPerPage}
                  setColumnContentSorter={setColumnInvoiceListSorter}
                  handleOnRowClick={handleOnRowInvoiceClick}
                  isClickable={true}
                />
              }
            />
            {
              user?.role_id == 1 && (
                <AppCard
                  className='mt-4 mb-4'
                  headerTitle={
                    <AppCardHeader
                      headerTitle={<span className='fs-6 fs-md-4'>Expenses related to project</span>}
                      headerButton="Create new expenses"
                      handleCardHeaderButton={handleShowModalCreateNewExpense}
                    />
                  }
                  bodyContent={
                    <AppTable
                      expenseListPage
                      tableFilter
                      setShowConfirmDelete={setShowDeleteItem}
                      tableColumns={columnExpenseList}
                      tableContent={expenseList}
                      contentPerPage={expenseListPerPage}
                      activeContentPage={activeExpenseListPage}
                      contentCount={expenseListCount}
                      searchContentFilter={searchExpenseListFilter}
                      setActiveContentPage={setActiveExpenseListPage}
                      setSearchContentFilter={handleSearchItemsExpense}
                      setContentPerPage={setExpenseListPerPage}
                      setColumnContentSorter={setColumnExpenseListSorter}
                      handleOnRowClick={handleOnRowExpenseClick}
                      isClickable={true}
                      isShowColumnFilter={true}
                      isShowButtonDuplicate={true}
                      isShowModalEdit={true}
                      setShowConfirmEdit={setShowConfirmEdit}
                      isShowModalDuplicate={true}
                      setShowConfirmDuplicate={setShowConfirmDuplicate}
                    />
                  }
                />
              )
            }
          </>
        }
        footerContent={
          <ActionButtonForm
            isLoading={isLoading}
            disabled={formik.isSubmitting}
            onCancel={() => navigate(`/project/details/${id}`)}
            onSave={() => setShowModalConfirm({ show: true })}
          />
        }
      />
    </>
  )
}

export default EditProject